export const INBOX_LOCAL_STORAGE_SELECTED_USER_IDS_KEY =
  "INBOX_NGI_SELECTED_USER_IDS";
export const INBOX_LOCAL_STORAGE_CONFIG_KEY = "INBOX_NGI_CONFIG";
export const INBOX_PERSISTED_KEYS = [
  INBOX_LOCAL_STORAGE_SELECTED_USER_IDS_KEY,
  INBOX_LOCAL_STORAGE_CONFIG_KEY,
];

export const INBOX_V2_VERSION = "v2";
export const INBOX_V4_VERSION = "v4";
